

































import { Component, Vue } from "vue-property-decorator";
import { PostsUsingContentTemplate } from "@/services/contentTemplates/types";

@Component
export default class ContentTemplateDeleteNotAllowedModal extends Vue {
    PostsUsingContentTemplate = [] as PostsUsingContentTemplate[];

    // methods
    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.PostsUsingContentTemplate = [];
    }

    open(data: PostsUsingContentTemplate[]) {
        this.PostsUsingContentTemplate = data;
        this.$bvModal.show("modal-deleteContentTemplateNotAllowed");
        window.addEventListener("keydown", this.handleEnter);
    }

    close() {
        this.$bvModal.hide("modal-deleteContentTemplateNotAllowed");
    }
}
